/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ReturnsTable_returnOrderEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaginatedReturnsContainer_returnOrders$ref: FragmentReference;
declare export opaque type PaginatedReturnsContainer_returnOrders$fragmentType: PaginatedReturnsContainer_returnOrders$ref;
export type PaginatedReturnsContainer_returnOrders = {|
  +returnOrders: {|
    +edges: ?$ReadOnlyArray<?{|
      +cursor: string,
      +$fragmentRefs: ReturnsTable_returnOrderEdges$ref,
    |}>
  |},
  +$refType: PaginatedReturnsContainer_returnOrders$ref,
|};
export type PaginatedReturnsContainer_returnOrders$data = PaginatedReturnsContainer_returnOrders;
export type PaginatedReturnsContainer_returnOrders$key = {
  +$data?: PaginatedReturnsContainer_returnOrders$data,
  +$fragmentRefs: PaginatedReturnsContainer_returnOrders$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaginatedReturnsContainer_returnOrders",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "returnOrders"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sortBy",
      "type": "ReturnOrderSort",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "statuses",
      "type": "[ReturnOrderStatus!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "returnTypes",
      "type": "[ReturnType!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "reasons",
      "type": "[ReturnReason!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "customerIds",
      "type": "[ID!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "orderIds",
      "type": "[ID!]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "returnOrders",
      "name": "__PaginatedReturnsContainer_returnOrders_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ReturnOrderConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ReturnOrderEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ReturnOrder",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ReturnsTable_returnOrderEdges",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c11788353a55755bea430c08457d1f13';
module.exports = node;
